import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { PasslyDropdown } from '@app/components';
import { changeJitOrganizationSelect, resetState } from '@app/store/actions';
import { localStore } from '@app/helpers';
import { jitUsersService } from '@app/services';
import { AxiosResponse } from 'axios';
import { IJitOrgsData, IJitOrgsProps } from '@app/models';
import { useTypedTranslation } from '@app/hooks';

export const JitOrganizationsSelect: React.SFC = () => {
    const { translation } = useTypedTranslation();

    const localStorageOrganization = localStore.getItem('jit_org_filter') ? localStore.getItem('jit_org_filter') : '';
    const [selectData, setSelectData] = useState<IJitOrgsProps[]>();
    const [selected, setSelected] = useState<string>();
    const dispatch = useDispatch();

    useEffect(() => {
        jitUsersService.getImpersonatedOrganizations().then((response: AxiosResponse) => {
            const data: IJitOrgsData[] = response.data.value;

            if (data) {
                const orgs = data.map((item) => {
                    return { id: item.OrganizationId, name: item.OrganizationName };
                });
                const initialOrg = orgs?.find((org: any) => org.id === localStorageOrganization)?.id || orgs[0]?.id;

                setSelectData(orgs);
                setSelected(initialOrg);
                dispatch(changeJitOrganizationSelect(initialOrg));
            }
        });
    }, []);

    const handleChange = (event: any) => {
        if (event.value !== selected) {
            dispatch(resetState());
            dispatch(changeJitOrganizationSelect(event.value));
            setSelected(event.value);
            localStore.setItem('jit_org_filter', event.value);
        }
    };

    return (
        <>
            {selectData && selectData?.length > 1 && (
                <PasslyDropdown
                    id='jitOrgSelector'
                    className='orgSelector'
                    value={selected}
                    options={selectData}
                    onChange={handleChange}
                    appendTo={document.body}
                    optionLabel='name'
                    optionValue='id'
                    label={translation('ORGANIZATION_SELECTION')}
                />
            )}
        </>
    );
};
